import React from "react"
import { footer, container, left, right } from "./footer.module.scss"

const Footer = () => {
  return (
    <footer className={footer}>
      <div className={container}>
        <p className={left}>&#169; Copyright &nbsp;Serjan Kairosh</p>
        <div className={right}>January 19, 2021</div>
      </div>
    </footer>
  )
}

export default Footer
